import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Activity, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { fmtDuration } from "@/components/activity/ActivityParts";

// Admin-Dashboard-Kachel: heutige Arbeitszeit je Nutzer (Top 3).
export function UserActivityTile() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/activity", { params: { period: "today" } }).then((r) => setData(r.data)).catch(() => setData(null));
  }, []);
  const top = (data?.users || []).slice(0, 3);
  return (
    <Link to="/admin/activity" data-testid="dashboard-user-activity-tile"
          className="block mb-6 bg-[#18181B] border border-zinc-800 hover:border-[#00E575]/40 rounded-2xl p-4 transition-colors group">
      <div className="flex items-center justify-between gap-3 mb-3">
        <div className="inline-flex items-center gap-2">
          <div className="h-9 w-9 rounded-xl bg-[#00E575]/15 border border-[#00E575]/30 flex items-center justify-center">
            <Activity size={16} className="text-[#00E575]" />
          </div>
          <div>
            <div className="text-[14px] font-bold text-zinc-100">Nutzer-Aktivität heute</div>
            <div className="text-[11.5px] text-zinc-500">Arbeitszeit je Nutzer · Beginn und Ende</div>
          </div>
        </div>
        <ArrowRight size={16} className="text-zinc-500 group-hover:text-[#00E575] group-hover:translate-x-0.5 transition-transform" />
      </div>
      <div className="grid grid-cols-2 gap-2 mb-3">
        <div className="rounded-xl bg-zinc-900/70 px-3 py-2">
          <div className="text-[10.5px] uppercase tracking-wider text-zinc-500 font-bold">Aktiv</div>
          <div className="text-[18px] font-bold font-mono text-zinc-100" data-testid="activity-tile-users">
            {data ? `${data.summary.active_users} / ${data.summary.total_users}` : "…"}
          </div>
        </div>
        <div className="rounded-xl bg-zinc-900/70 px-3 py-2">
          <div className="text-[10.5px] uppercase tracking-wider text-zinc-500 font-bold">Arbeitszeit gesamt</div>
          <div className="text-[18px] font-bold font-mono text-[#00E575] truncate" data-testid="activity-tile-total">
            {data ? fmtDuration(data.summary.work_minutes) : "…"}
          </div>
        </div>
      </div>
      {top.length > 0 ? (
        <div className="space-y-1">
          {top.map((u) => (
            <div key={u.id} className="flex items-center justify-between gap-2 text-[12.5px]" data-testid={`activity-tile-user-${u.id}`}>
              <span className="text-zinc-200 truncate">{u.name}</span>
              <span className="font-mono text-zinc-400 shrink-0">{u.first_start}–{u.last_end} · <b className="text-zinc-100">{fmtDuration(u.work_minutes)}</b></span>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-[12.5px] text-zinc-500">{data ? "Heute noch niemand aktiv." : "Lädt …"}</div>
      )}
    </Link>
  );
}
